import axios from 'axios';
import { setTokenFor } from '../../services/tokenStore';

const isDevelopment = window.location.hostname === 'localhost';
const cookieDomain = isDevelopment
  ? process.env.REACT_APP_COOKIE_DOMAIN || '.localhost'
  : process.env.REACT_APP_COOKIE_DOMAIN || '.ilaws.net';


export const callLoginApi = async (
  endpoint,
  method = 'GET',
  data = null,
  onSuccess,
  headers,
  params
  //   setRefreshCaptcha,
  //   setLawForUser,
  //   setCookieToken
) => {
  try {
    const response = await axios({
      url: `${process.env.REACT_APP_BASE_URL_PROFILE}${endpoint}`, // api address
      method, // type of request (get,post,...)
      ...(data && { data }), // if data or params exists
      ...(params && { params }),
      ...(headers && { headers }),
    });

    // setLoading(false);
    // console.log(response);

    if (
      // response[0] === "Password : The Password field is required." ||
      // response[0] === "user not found" ||
      // response[0] === "UserName : The UserName field is required." ||
      // response[0] === "you should go to the login." ||
      // response[0] === "invalid informatiom." ||
      response.data.statusCode !== 200
    ) {
      // alert('نام ورود یا کلمه عبور اشتباه است، لطفا دوباره تلاش کنید.');
      alert(response.data.message);
      //   setRefreshCaptcha(true);
    } else {
      // Store profile token in unified token store
      setTokenFor('profile', response.data);
      onSuccess(response.data);
      //setCookieToken(response.data);
    }
    return response.data;
  } catch (error) {
    console.log('errorFetchLoginJWT: ', error);
  }
};
